import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tree_org_node = _resolveComponent("tree-org-node")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _withDirectives(_createElementVNode("div", {
      id: "clone-tree-org",
      class: _normalizeClass(["clone-tree-org tree-org", { horizontal: _ctx.horizontal, collapsable: _ctx.collapsable }])
    }, [
      _createVNode(_component_tree_org_node, {
        data: _ctx.data,
        props: _ctx.props,
        isClone: false,
        horizontal: _ctx.horizontal,
        labelStyle: _ctx.labelStyle,
        collapsable: _ctx.collapsable,
        renderContent: _ctx.renderContent,
        labelClassName: _ctx.labelClassName
      }, _createSlots({ _: 2 }, [
        (_ctx.defaultSlot)
          ? {
              name: "default",
              fn: _withCtx(({node}) => [
                _renderSlot(_ctx.$slots, "default", { node: node })
              ])
            }
          : undefined,
        (_ctx.expandSlot)
          ? {
              name: "expand",
              fn: _withCtx(({node}) => [
                _renderSlot(_ctx.$slots, "expand", { node: node })
              ])
            }
          : undefined
      ]), 1032, ["data", "props", "horizontal", "labelStyle", "collapsable", "renderContent", "labelClassName"])
    ], 2), [
      [_vShow, _ctx.modelValue]
    ])
  ]))
}